import * as angular from 'angular';
import notificationSystemsRouter from './notificationSystemsRouter';
import notificationSystemsService from './notificationSystems.service';
import notifiersService from './notifiers/notifiers.service';
import endpointsService from './endpoints/endpoints.service';

/** @constant {angular.module} */
const webhooksModule = angular
  .module('ec.opsCenter.webhooks', [])
  .config(notificationSystemsRouter)
  .service('notificationSystemsService', notificationSystemsService)
  .service('notifiersService', notifiersService)
  .service('endpointsService', endpointsService)
  .name;

export default webhooksModule;



// WEBPACK FOOTER //
// ./src/app/webhooks/webhooks.module.ts